import * as Sentry from '@sentry/browser';
import { createErrorObject } from './errorHandler';
import axios from 'axios';

const EIQ_SERVER = import.meta.env.VITE_EIQ_SERVER;
const EIQ_SERVER_HTTP = import.meta.env.VITE_EIQ_SERVER_HTTP;

const apiInstance = axios.create({})

const handleWebSocketError = (socket, handleSocketError) => {
  socket.onerror = (error) => {
    const customError = createErrorObject(error);
    handleSocketError(customError);
  };
};

const connectEIQWebsockets = async (socket, handleSocketError, handleOnSocketClose) => {
  if (socket.value?.readyState === WebSocket.OPEN) {
    // Client already connected
    return;
  }

  // Create WebSocket connection.
  socket.value = new WebSocket(EIQ_SERVER);

  // Connection opened
  await new Promise((resolve, reject) => {
    socket.value.onopen = () => {
      resolve();
    };
    socket.value.onerror = (error) => {
      Sentry.captureException(error);
      reject(error);
    };

    // The close event has more information about why the connection was closed.
    socket.value.onclose = (event) => {
      handleOnSocketClose()
    };
  });

  // Listen for error events
  handleWebSocketError(socket, handleSocketError);

};

const sendEIQDataToWebsockets = (socket, eiqData, onMessageReceived) => {
  // Send eIQ data to the server
  socket.value.send(JSON.stringify(eiqData));

  // Listen for package events
  socket.value.onmessage = (event) => {
    const data = JSON.parse(event.data);
    onMessageReceived(data);
  };
};

const disconnectEIQWebsockets = (socket) => {
  if (socket.value?.readyState === WebSocket.OPEN) {
    socket.value?.close();
    return;
  }
};

const reQuote = async (data) => {
  const url = EIQ_SERVER_HTTP
  try {
    const resp = await apiInstance({method: 'post', url: url, data})
    return resp.data
  } catch (error) {
    console.log(error);
  }
}

export {
  connectEIQWebsockets, 
  disconnectEIQWebsockets, 
  sendEIQDataToWebsockets,
  reQuote,
};
